// Flat checkbox rows for pending or existing subtasks inside TaskForm.
import { Box, Checkbox, Typography } from '@mui/material';

export const renderTitleError = (errors) => {
  if (!errors.title) return null;
  return (
    <Typography
      color="error"
      variant="caption"
      sx={{ display: 'block', mt: 0.5 }}
    >
      {errors.title}
    </Typography>
  );
};

export const renderFlatSubtaskRows = (rows, onToggle) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, pl: 0.5 }}>
    {rows.map((st) => (
      <Box
        key={st.localId || st.id}
        sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.25 }}
      >
        <Checkbox
          size="small"
          checked={!!st.completed}
          onChange={(e) => onToggle(st, e.target.checked)}
          sx={{ p: 0 }}
        />
        <Typography
          variant="body2"
          sx={{
            flex: 1,
            textDecoration: st.completed ? 'line-through' : 'none',
            color: st.completed ? 'text.subtle' : 'text.primary',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {st.title}
        </Typography>
      </Box>
    ))}
  </Box>
);
